import { Button, Div, Logo } from 'ui'
import useResponsive from 'utils/hooks/useResponsive'
import React from 'react'
import { useTranslation } from 'react-i18next'

const Header = () => {

  const { t } = useTranslation()
  const { isMobile } = useResponsive()

  return (
    <Div
      background='linear-gradient(180deg, #FFFFFF 0%, rgba(255, 255, 255, 0.991615) 11.79%, rgba(255, 255, 255, 0.967585) 21.38%, rgba(255, 255, 255, 0.9296) 29.12%, rgba(255, 255, 255, 0.879348) 35.34%, rgba(255, 255, 255, 0.818519) 40.37%, rgba(255, 255, 255, 0.7488) 44.56%, rgba(255, 255, 255, 0.671881) 48.24%, rgba(255, 255, 255, 0.589452) 51.76%, rgba(255, 255, 255, 0.5032) 55.44%, rgba(255, 255, 255, 0.414815) 59.63%, rgba(255, 255, 255, 0.325985) 64.66%, rgba(255, 255, 255, 0.2384) 70.88%, rgba(255, 255, 255, 0.153748) 78.62%, rgba(255, 255, 255, 0.0737185) 88.21%, rgba(255, 255, 255, 0) 100%)'
      height='72px'
      display='flex'
      alignItems='center'
      justifyContent='space-between'
      padding={isMobile ? '0 16px' : '0 40px'}
      marginBottom={64}
    >
      <Logo theme='light' />

      <Button
        openNewTab
        to={{ pathname: 'mailto:content@flixxo.com' }}
        size='small'
      >
        {t('beCreator')}
      </Button>
    </Div>
  )
}

export default Header